export default class MeveoUser {
  constructor(datum) {
    this.username = datum.username || "";
    this.password = datum.password;
    this.email = datum.email;
    this.externalRole = datum.externalRole;
  }

  get meveoJson(){
    return JSON.stringify(this);
  }

}



// WEBPACK FOOTER //
// ./src/opencell/model/MeveoUser.js